import { AR_lang, EN_lang, FR_lang, PT_lang } from '@entities/language';
import type { LanguageConfig } from '@entities/language/model/types';

const UNSUB_GEO_LANGUAGE_BY_COUNTRY: Record<string, LanguageConfig> = {
  ly: AR_lang,
  dz: FR_lang,
  pt: PT_lang,
};

const dedupeLanguages = (languages: LanguageConfig[]) => {
  const byLang = new Map<string, LanguageConfig>();

  languages.forEach((language) => {
    byLang.set(language.lang, language);
  });

  return [...byLang.values()];
};

export const getUnsubLanguageConfig = (country = '') => {
  const normalizedCountry = (country || '').toLowerCase();
  const geoLanguage = UNSUB_GEO_LANGUAGE_BY_COUNTRY[normalizedCountry] || AR_lang;

  if (normalizedCountry === 'pt') {
    return {
      availableLanguages: dedupeLanguages([PT_lang, EN_lang]),
      showLanguageSelector: false,
    };
  }

  return {
    availableLanguages: dedupeLanguages([EN_lang, geoLanguage, AR_lang, FR_lang]),
  };
};
